/**
 * 
 * key
 * 
 */


const key = 'aW52ZW50b3J5TGlzdA=='

export default key 